import { useDispatch, useSelector } from "react-redux";
 
import PageTopTitle from "../../components/shared/PageTopTitle";
import styled from "styled-components";

import GarajListItem from "../../components/garaj/GarajListItem";
import { useEffect } from "react";
import { getGarajYogunluk } from "../../features/admin/adminSlice";
import { useState } from "react";

const Container = styled.div`
  width: 100%;

  .wrapper {
    display: flex;
    flex-direction: column;
    width: 100%;

    .content {
      width: calc(80% - 60px);
      gap: 60px;
      margin: 30px;
      @media (max-width: 1550px) {
        margin: 0;
        padding: 30px;
        width: 100%;
      }

      .list {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 10px;
      }
    }
  }
`;

const GarajYogunlugu = () => {

  const { garajYogunlukList } = useSelector((state) => state.admin);
  const [formattedList, setFormattedList] = useState([]);

  const dispatch = useDispatch();

  useEffect(() => {
    if (garajYogunlukList.length > 0) {
      setFormattedList(
        garajYogunlukList.map((item) => {
          const date = new Date(item.entryTime);
          return {
            ...item,
            entryTime: date.toLocaleDateString(),
            time: date.toLocaleTimeString(),
          };
        })
      );
    }
  }, [garajYogunlukList]);

  //! #0EAC00
  //! #EBB00E
  //! #FF0000

  useEffect(() => {
    dispatch(getGarajYogunluk());
  }, []);


  return (
    <Container>
      <div className="wrapper">
        <PageTopTitle title={"Garaj Yoğunluğu"} position="sticky" />
        <div className="content">
          <div className="list">
            {formattedList.map((item) => (
              <GarajListItem key={item.branchId} item={item} />
            ))}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default GarajYogunlugu;
